import {
  FILE_TYPE_HTML,
  FILE_TYPE_PDF,
  FILE_TYPE_ZIP,
  HTML_FILE,
  PDF_FILE,
  ZIP_FILE
} from 'components/CreateUpdateSiteModal/interface'
import JSZip from 'jszip'
import { isHtml } from './general'

const metadataFilesPath = ['__MACOSX', '.DS_Store', 'Thumbs.db', '/._']

export const findHtmlFilesInZipFile = async (file) => {
  let htmlFiles = []
  try {
    const reader = new FileReader()
    reader.readAsArrayBuffer(file)

    await new Promise((resolve, reject) => {
      reader.onload = resolve
      reader.onerror = reject
    })

    const content = reader.result
    const zip = await JSZip.loadAsync(content)

    zip.forEach((path) => {
      if (path.endsWith('.html') && !metadataFilesPath.some((metadataFilePath) => path.includes(metadataFilePath))) {
        const index = path.indexOf('/')
        if (index === -1) {
          htmlFiles.push(path)
        } else {
          const secondIndex = path.substring(index + 1).indexOf('/')

          if (secondIndex === -1) {
            htmlFiles.push(path.substring(index + 1))
          }
        }
      }
    })
  } catch (error) {
    console.log(error)
  }

  return htmlFiles
}

export const getZipRootDirectory = (unzippedFiles) => {
  const index = unzippedFiles[0].path.indexOf('/')

  if (unzippedFiles[0].type === 'Directory' && unzippedFiles[0].path.substring(index + 1) === '') {
    return unzippedFiles[0].path
  }
  return ''
}

export const isIndexFile = (htmlFiles) => {
  if (htmlFiles.length > 1)
    return htmlFiles.some((htmlFile) => {
      return htmlFile.split('/')[1] === 'index.html' || htmlFile.split('/')[0] === 'index.html'
    })

  return true
}

export const getFileType = (fileName) => {
  if (fileName?.endsWith('.pdf')) {
    return PDF_FILE
  } else if (fileName?.endsWith('.zip')) {
    return ZIP_FILE
  } else if (fileName?.endsWith('.html')) {
    return HTML_FILE
  } else {
    return null
  }
}

export const getFileContentType = (fileName) => {
  if (fileName?.endsWith('.pdf')) {
    return FILE_TYPE_PDF
  } else if (fileName?.endsWith('.zip')) {
    return FILE_TYPE_ZIP
  } else if (fileName?.endsWith('.html')) {
    return FILE_TYPE_HTML
  } else {
    return null
  }
}

export const isHtmlFileExisting = (files) => {
  let isHtmlFileFound = false
  files.map((file) => {
    if (getFileType(file?.name) === HTML_FILE) {
      isHtmlFileFound = true
    }
  })
  return isHtmlFileFound
}

export const isIndexFileExisting = (files) => {
  if (isHtmlFileExisting(files)) {
    let isIndexFileFound = false

    files.map((file) => {
      if (file?.name === 'index.html') {
        isIndexFileFound = true
      }
    })
    return isIndexFileFound
  }

  return true
}

export const sortAllHtmlFiles = (files) => {
  return files.map((file) => {
    if (isHtml(file)) {
      return file.path
    }
  })
}

export const getSafeFilename = (fileName) => {
  const index = fileName.lastIndexOf('.')
  const name = fileName.substring(0, index)
  const ext = fileName.substring(index + 1)

  return `${name.replace(/[-\s.]+/g, '_')}.${ext}`
}

export const getTrimmedZipFileName = (fileName) => {
  const index = fileName.lastIndexOf('.')
  const name = fileName.substring(0, index)

  return name.indexOf(' ') === -1 ? name : `${name.substring(0, name.indexOf(' '))}`
}
